//POS SYSTEM Action Types

///possystem/render
export const GET_POS_SYSTEM_RENDER_DATA = "GET_POS_SYSTEM_RENDER_DATA";
export const GET_POS_SYSTEM_RENDER_DATA_SUCCESS = 'GET_POS_SYSTEM_RENDER_DATA_SUCCESS';
export const GET_POS_SYSTEM_RENDER_DATA_FAILURE = 'GET_POS_SYSTEM_RENDER_DATA_FAILURE';

///possystem/list
export const GET_POS_SYSTEM_LIST = "GET_POS_SYSTEM_LIST";
export const GET_POS_SYSTEM_LIST_SUCCESS = "GET_POS_SYSTEM_LIST_SUCCESS";
export const GET_POS_SYSTEM_LIST_FAILURE = "GET_POS_SYSTEM_LIST_FAILURE";

///possystem/data/
export const GET_POS_SYSTEM_DATA = "GET_POS_SYSTEM_DATA";
export const GET_POS_SYSTEM_DATA_SUCCESS = "GET_POS_SYSTEM_DATA_SUCCESS";
export const GET_POS_SYSTEM_DATA_FAILURE = "GET_POS_SYSTEM_DATA_FAILURE";

///possystem/create
export const CREATE_POS_SYSTEM = "CREATE_POS_SYSTEM";
export const CREATE_POS_SYSTEM_SUCCESS = "CREATE_POS_SYSTEM_SUCCESS";
export const CREATE_POS_SYSTEM_FAILURE = "CREATE_POS_SYSTEM_FAILURE";

///possystem/update
export const UPDATE_POS_SYSTEM = "UPDATE_POS_SYSTEM";
export const UPDATE_POS_SYSTEM_SUCCESS = "UPDATE_POS_SYSTEM_SUCCESS";
export const UPDATE_POS_SYSTEM_FAILURE = "UPDATE_POS_SYSTEM_FAILURE";

///possystem/delete
export const DELETE_POS_SYSTEM = "DELETE_POS_SYSTEM";
export const DELETE_POS_SYSTEM_SUCCESS = "DELETE_POS_SYSTEM_SUCCESS";
export const DELETE_POS_SYSTEM_FAILURE = "DELETE_POS_SYSTEM_FAILURE";

// POS SYSTEM TO USER Action Types
///possystemtouser/list
export const GET_POS_SYSTEM_TO_USER_LIST = "GET_POS_SYSTEM_TO_USER_LIST";
export const GET_POS_SYSTEM_TO_USER_LIST_SUCCESS = "GET_POS_SYSTEM_TO_USER_LIST_SUCCESS";
export const GET_POS_SYSTEM_TO_USER_LIST_FAILURE = "GET_POS_SYSTEM_TO_USER_LIST_FAILURE";

///possystemtouser/data/
export const GET_POS_SYSTEM_TO_USER_DATA = "GET_POS_SYSTEM_TO_USER_DATA";
export const GET_POS_SYSTEM_TO_USER_DATA_SUCCESS = "GET_POS_SYSTEM_TO_USER_DATA_SUCCESS";
export const GET_POS_SYSTEM_TO_USER_DATA_FAILURE = "GET_POS_SYSTEM_TO_USER_DATA_FAILURE";

///possystemtouser/create
export const CREATE_POS_SYSTEM_TO_USER = "CREATE_POS_SYSTEM_TO_USER";
export const CREATE_POS_SYSTEM_TO_USER_SUCCESS = "CREATE_POS_SYSTEM_TO_USER_SUCCESS";
export const CREATE_POS_SYSTEM_TO_USER_FAILURE = "CREATE_POS_SYSTEM_TO_USER_FAILURE";

///possystemtouser/update
export const UPDATE_POS_SYSTEM_TO_USER = "UPDATE_POS_SYSTEM_TO_USER";
export const UPDATE_POS_SYSTEM_TO_USER_SUCCESS = "UPDATE_POS_SYSTEM_TO_USER_SUCCESS";
export const UPDATE_POS_SYSTEM_TO_USER_FAILURE = "UPDATE_POS_SYSTEM_TO_USER_FAILURE";

///possystemtouser/delete
export const DELETE_POS_SYSTEM_TO_USER = "DELETE_POS_SYSTEM_TO_USER";
export const DELETE_POS_SYSTEM_TO_USER_SUCCESS = "DELETE_POS_SYSTEM_TO_USER_SUCCESS";
export const DELETE_POS_SYSTEM_TO_USER_FAILURE = "DELETE_POS_SYSTEM_TO_USER_FAILURE";

///posorder/list
export const GET_POS_ORDER_LIST = "GET_POS_ORDER_LIST";
export const GET_POS_ORDER_LIST_SUCCESS = "GET_POS_ORDER_LIST_SUCCESS";
export const GET_POS_ORDER_LIST_FAILURE = "GET_POS_ORDER_LIST_FAILURE";

///posorder/search
export const POS_ORDER_SEARCH = "POS_ORDER_SEARCH";
export const POS_ORDER_SEARCH_SUCCESS = "POS_ORDER_SEARCH_SUCCESS";
export const POS_ORDER_SEARCH_FAILURE = "POS_ORDER_SEARCH_FAILURE";

///posorder/data
export const GET_POS_ORDER_DATA = "GET_POS_ORDER_DATA";
export const GET_POS_ORDER_DATA_SUCCESS = "GET_POS_ORDER_DATA_SUCCESS";
export const GET_POS_ORDER_DATA_FAILURE = "GET_POS_ORDER_DATA_FAILURE";

///posorder/create
export const CREATE_POS_ORDER = "CREATE_POS_ORDER";
export const CREATE_POS_ORDER_SUCCESS = "CREATE_POS_ORDER_SUCCESS";
export const CREATE_POS_ORDER_FAILURE = "CREATE_POS_ORDER_FAILURE";

///posorder/update
export const UPDATE_POS_ORDER = "UPDATE_POS_ORDER";
export const UPDATE_POS_ORDER_SUCCESS = "UPDATE_POS_ORDER_SUCCESS";
export const UPDATE_POS_ORDER_FAILURE = "UPDATE_POS_ORDER_FAILURE";

///posorder/delete
export const DELETE_POS_ORDER = "DELETE_POS_ORDER";
export const DELETE_POS_ORDER_SUCCESS = "DELETE_POS_ORDER_SUCCESS";
export const DELETE_POS_ORDER_FAILURE = "DELETE_POS_ORDER_FAILURE";

///posorder/paymentrequest
export const CREATE_POS_ORDER_PAYMENT_REQUEST = "CREATE_POS_ORDER_PAYMENT_REQUEST";
export const CREATE_POS_ORDER_PAYMENT_REQUEST_SUCCESS = "CREATE_POS_ORDER_PAYMENT_REQUEST_SUCCESS";
export const CREATE_POS_ORDER_PAYMENT_REQUEST_FAILURE = "CREATE_POS_ORDER_PAYMENT_REQUEST_FAILURE";

///posorder/tender (cash / voucher / account - non-card tenders)
export const CREATE_POS_ORDER_TENDER = "CREATE_POS_ORDER_TENDER";
export const CREATE_POS_ORDER_TENDER_SUCCESS = "CREATE_POS_ORDER_TENDER_SUCCESS";
export const CREATE_POS_ORDER_TENDER_FAILURE = "CREATE_POS_ORDER_TENDER_FAILURE";

//INTERNAL_TERMINAL_PAYMENT_RESULT
export const INTERNAL_TERMINAL_PAYMENT_RESULT = "INTERNAL_TERMINAL_PAYMENT_RESULT";
export const INTERNAL_TERMINAL_PAYMENT_RESULT_SUCCESS = "INTERNAL_TERMINAL_PAYMENT_RESULT_SUCCESS";
export const INTERNAL_TERMINAL_PAYMENT_RESULT_FAILURE = "INTERNAL_TERMINAL_PAYMENT_RESULT_FAILURE";

//Internal Pos System Tickets Update
export const INTERNAL_POS_SYSTEM_TICKETS_UPDATE = "INTERNAL_POS_SYSTEM_TICKETS_UPDATE";
export const INTERNAL_POS_SYSTEM_TICKETS_UPDATE_SUCCESS = "INTERNAL_POS_SYSTEM_TICKETS_UPDATE_SUCCESS";
export const INTERNAL_POS_SYSTEM_TICKETS_UPDATE_FAILURE = "INTERNAL_POS_SYSTEM_TICKETS_UPDATE_FAILURE";

///possystem/overview
export const GET_POS_SYSTEM_OVERVIEW = "GET_POS_SYSTEM_OVERVIEW";
export const GET_POS_SYSTEM_OVERVIEW_SUCCESS = "GET_POS_SYSTEM_OVERVIEW_SUCCESS";
export const GET_POS_SYSTEM_OVERVIEW_FAILURE = "GET_POS_SYSTEM_OVERVIEW_FAILURE";

///paymentrequest/void
export const VOID_POS_ORDER_PAYMENT_REQUEST = "VOID_POS_ORDER_PAYMENT_REQUEST";
export const VOID_POS_ORDER_PAYMENT_REQUEST_SUCCESS = "VOID_POS_ORDER_PAYMENT_REQUEST_SUCCESS";
export const VOID_POS_ORDER_PAYMENT_REQUEST_FAILURE = "VOID_POS_ORDER_PAYMENT_REQUEST_FAILURE";

///posorder/receipt/print
export const PRINT_POS_ORDER_RECEIPT = "PRINT_POS_ORDER_RECEIPT";
export const PRINT_POS_ORDER_RECEIPT_SUCCESS = "PRINT_POS_ORDER_RECEIPT_SUCCESS";
export const PRINT_POS_ORDER_RECEIPT_FAILURE = "PRINT_POS_ORDER_RECEIPT_FAILURE";

///posorder/receipt/email
export const EMAIL_POS_ORDER_RECEIPT = "EMAIL_POS_ORDER_RECEIPT";
export const EMAIL_POS_ORDER_RECEIPT_SUCCESS = "EMAIL_POS_ORDER_RECEIPT_SUCCESS";
export const EMAIL_POS_ORDER_RECEIPT_FAILURE = "EMAIL_POS_ORDER_RECEIPT_FAILURE";

///posorder/refund
export const REFUND_POS_ORDER = "REFUND_POS_ORDER";
export const REFUND_POS_ORDER_SUCCESS = "REFUND_POS_ORDER_SUCCESS";
export const REFUND_POS_ORDER_FAILURE = "REFUND_POS_ORDER_FAILURE";